export default __webpack_public_path__ + "static/media/secre de innovacion.a3827bb0.png";